











import Vue from 'vue';
import SideBar from '@/parts/about/SideBar.vue';

export default Vue.extend({
  name: 'Announcements',
  components: {
    SideBar,
  },
})
